module.exports = __webpack_public_path__ + "static/img/19.d6017b94.png";